import { render, staticRenderFns } from "./InteractionsHeader.vue?vue&type=template&id=0d1fd5c6&scoped=true"
import script from "./InteractionsHeader.vue?vue&type=script&lang=js"
export * from "./InteractionsHeader.vue?vue&type=script&lang=js"
import style0 from "./InteractionsHeader.vue?vue&type=style&index=0&id=0d1fd5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fd5c6",
  null
  
)

export default component.exports